import React from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';

export const CreateRelationshipContactButton = () => {
	const dispatch = useDispatch();

	const handleOpenDialog = () => {
		dispatch(
			openDialog({
				dialogName: 'relationshipContact',
			}),
		);
	};

	return (
		<div style={{ display: 'flex', justifyContent: 'right', paddingBottom: '1em' }}>
			<Button variant='tab_header' startIcon={<Add />} onClick={handleOpenDialog}>
				Add contact
			</Button>
		</div>
	);
};
